import { axiosInstance } from "@/lib/api";
import type { Session } from "@/components/gettingIn/authApi";

export type InvitationState = "open" | "ended" | "withdrawn" | "joined" | "declined" | "no_seat";

/** GET /auth/invitations/:id (backend InvitationLinkUseCases.read). */
export interface Invitation {
  id: string;
  state: InvitationState;
  email: string;
  role: string;
  workspace: { name: string };
  inviter: { name: string | null; email: string | null };
  brands: string[];
  expiresAt: string;
  acceptedAt: string | null;
  revokedAt: string | null;
  revokedBy: { name: string | null } | null;
  maxSeats: number | null;
  hasAccount: boolean;
  hasPassword: boolean;
}

export const invitationCalls = {
  read: (id: string) => axiosInstance.get<Invitation>(`/auth/invitations/${id}`).then((r) => r.data),
  join: (id: string, name: string, password: string) =>
    axiosInstance.post<Session>(`/auth/invitations/${id}/join`, { name, password }).then((r) => r.data),
  joinWithGoogle: (id: string, accessToken: string) =>
    axiosInstance
      .post<Session>(`/auth/invitations/${id}/join-google`, { accessToken }, { skipAuthRefresh: true })
      .then((r) => r.data),
  /** Signed in already: the in-app accept (Settings 09's). */
  accept: (id: string) =>
    axiosInstance
      .post<{ organizationId: string }>(`/organization/invite/${id}/accept`)
      .then((r) => r.data),
};

/**
 * "Not for me" is sent when the page goes away, so Undo is free until then
 * (M07). A beacon: no headers, no preflight, it outlives the tab.
 */
export function sendDecline(id: string) {
  const url = axiosInstance.getUri({ url: `/auth/invitations/${id}/decline` });
  try {
    if (navigator.sendBeacon?.(url)) return;
  } catch {
    /* fall through */
  }
  void fetch(url, { method: "POST", keepalive: true }).catch(() => {});
}

/** "Ghazi" from "Ghazi Al Yaman"; the address's local part when there is no name. */
export function firstName(name: string | null | undefined, email?: string | null): string {
  const first = name?.trim().split(/\s+/)[0];
  if (first) return first;
  return email?.split("@")[0] ?? "them";
}
